import * as angular from 'angular';

export class VersionService {
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    getCurrentVersion() {
        return this.$http.get('version.json');
    }
}

angular
    .module('app')
    .service('VersionService', VersionService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/version.factory.ts